import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PayoutAccountAPI } from '../../api';
import { AddPayoutAccountPayPalForm } from '../../components';
import { PayoutProvider } from '../../utils/types/Entity';
import { AddPayPalAccountContainerProps } from './AddPayPalAccountContainer.types';
import AddPayoutAccountBaseModule from '../AddPayoutAccountBaseModule/AddPayoutAccountBaseModule';

const AddPayPalAccountContainer: React.FC<AddPayPalAccountContainerProps> = ({
  onBackClick,
}) => {
  const { t } = useTranslation();
  const { getAccessTokenSilently } = useAuth0();
  const [processingRequest, setProcessingRequest] = useState(false);
  const [createAccountError, setCreateAccountError] = useState('');
  const resetErrorMessage = useCallback((): void => {
    setCreateAccountError('');
  }, []);

  const startPayPalLogin = async (): Promise<void> => {
    setCreateAccountError('');
    setProcessingRequest(true);

    try {
      const accessToken = await getAccessTokenSilently();
      const authorizationURL =
        await PayoutAccountAPI.getProviderAuthorizationURL(
          accessToken,
          PayoutProvider.PayPal,
        );
      window.location.assign(authorizationURL);
    } catch (_error) {
      setProcessingRequest(false);
      setCreateAccountError(t('error.paypal_login_failed'));
    }
  };

  return (
    <AddPayoutAccountBaseModule
      step={0}
      stepTitles={{ 0: t('sunshine.label.connect_paypal') }}
      provider={PayoutProvider.PayPal}
      formReady={false}
      formID="add_paypal_form"
      processingRequest={processingRequest}
      errorMsg=""
      resetErrorMsg={resetErrorMessage}
      exit={onBackClick}
      edit={(): void => undefined}
      save={(): void => undefined}
      disableSteps
    >
      <AddPayoutAccountPayPalForm
        errorMsg={createAccountError}
        onLogIn={(): void => void startPayPalLogin()}
        processingRequest={processingRequest}
      />
    </AddPayoutAccountBaseModule>
  );
};

export default AddPayPalAccountContainer;
